var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRepeat = function SvgRepeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#repeat_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67,
    d: "M14.167.833 17.5 4.167m0 0L14.167 7.5M17.5 4.167H5.833A3.333 3.333 0 0 0 2.5 7.5v1.667m3.333 10L2.5 15.833m0 0L5.833 12.5M2.5 15.833h11.667A3.333 3.333 0 0 0 17.5 12.5v-1.667"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "repeat_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgRepeat;